import angular from "angular";

angular
	.module('app')
	.component('trIndexPage', {
		template: require('./tr-index-page.html'),
        controller: ['$http', controller],
        bindings: {
		    branches:'<'
        }
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.selectedBranch = null;
	$ctrl.selectedCar = null;

	$ctrl.$onInit = function () {

    };

	$ctrl.selectBranch = function (key) {
		$ctrl.selectedBranch = key;
		$ctrl.selectedCar = null;
	}

	$ctrl.selectCar = function (key) {
		$ctrl.selectedCar = key;
	}

	$ctrl.unSelectBranch = function () {
		$ctrl.selectedCar = null
		$ctrl.selectedBranch = null;
	}

	$ctrl.unSelectCar = function () {
		$ctrl.selectedCar = null;
	}
}
